<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="1000px"
    @closed="handleClose"
    append-to-body
    :close-on-click-modal="false"
  >
    <el-scrollbar class="my-scroll">
      <div class="rule-ot-wrap">
        <el-form ref="form" :model="form" label-width="200px" size="small" :rules="rules">
          <!-- 规则名称 -->
          <el-form-item :label="$t('1688')" prop="name">
            <el-input v-model.trim="form.name" :maxlength="30" show-word-limit :placeholder="$t('850')"></el-input>
          </el-form-item>
          <!-- 适用范围 -->
          <el-form-item :label="$t('1601')" prop="selectedFormate">
            <el-input
              type="textarea"
              v-model="form.selectedFormate"
              @click.native="openOrg"
              :placeholder="$t('221')"
              readonly
              style="width: 200px"
            ></el-input>
          </el-form-item>
          <!-- 申请时间格式 -->
          <el-form-item :label="$t('1691')">
            <el-radio-group v-model="form.time_format">
              <!-- 不限制 -->
              <el-radio :label="1">{{ $t('138') }}</el-radio>
              <!-- 只能选择整点半点 -->
              <el-radio :label="2">{{ $t('1692') }}</el-radio>
              <!-- 说明 -->
            </el-radio-group>
            <el-tooltip effect="dark" :content="$t('1705')" placement="right">
              <i class="el-icon-info"></i>
            </el-tooltip>
          </el-form-item>
          <!-- taps 切换 -->
          <el-tabs v-model="activeName" type="card" size="small">
            <el-tab-pane
              :label="$t(item === 'working_day' ? '1701' : item)"
              :name="item"
              v-for="(item, index) in otRuleTaps"
              :key="item"
            >
              <form-item
                :form="form.settings[item]"
                :ruleKey="item"
                :time-option="timeOption"
                :key="index + item"
                @changeData="handlerChangeState"
              />
            </el-tab-pane>
          </el-tabs>
        </el-form>
      </div>
    </el-scrollbar>
    <!-- 确认取消 -->
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false" size="small">{{ $t('66') }}</el-button>
      <el-button type="primary" @click="handldSave" size="small">{{ $t('131') }}</el-button>
    </span>
    <!-- {{ form.staff_ids }} -->
    <!-- 人员选择 -->
    <Org
      @onConfirm="handleSelectDepart"
      v-if="orgVisible"
      :visible.sync="orgVisible"
      :defaultDepatment="form.department_ids"
      :defaultEmployess="form.staff_ids"
    />
  </el-dialog>
</template>

<script>
import '@/views/payroll/directive.js'
import Org from '@/components/organization'
import { applyDeyail, applyAdd, applyEdit } from 'api/approval/config'
import rules from './rule'
import { all, half, defaultSettings, otRuleTaps, timeInterval } from '../enmu'
import formItem from './form.vue'

export default {
  components: {
    Org,
    formItem
  },
  props: {
    type: {
      type: String,
      default: 'add'
    },
    applyId: {
      default: ''
    }
  },
  mixins: [rules],
  data() {
    return {
      visible: false,
      orgVisible: false, // 人员组织组件visible
      activeName: otRuleTaps[0], // taps value
      otRuleTaps, // taps enmu
      // 时间选择option负责
      form: {
        is_default: '0', // 是否是默认加班规则
        name: '',
        time_format: 1, // 申请时间格式1 不限制 2 只能选择整点/半点
        // 适用范围
        department_ids: [],
        staff_ids: [],
        selectedFormate: '', // 已选范围formate文案
        settings: defaultSettings()
      }
    }
  },
  computed: {
    title() {
      return this.type === 'add' ? this.$t('132') : this.$t('71')
    },
    // 日期组件picker options
    timeOption() {
      return this.time_format === 1 ? all : half
    },
    // 生成已选文案
    // @example 张三等3个人 法务部等10个部门
    selectedFormate() {
      if (this.form.is_default !== '0') return this.$t('1707')
      const { staff_ids, department_ids } = this.form
      const staffStart = staff_ids[0]
      const departStart = department_ids[0]
      const staffText = staffStart
        ? staffStart.staff_name + (staff_ids.length > 1 ? this.$t('1653', { x: staff_ids.length }) : '')
        : ''
      const departText = departStart
        ? (staffText ? ', ' : '') +
          departStart.department_name +
          (department_ids.length > 1 ? this.$t('1654', { x: department_ids.length }) : '')
        : ''
      return staffText + departText
    }
  },
  watch: {
    selectedFormate(v) {
      this.form.selectedFormate = v
    }
  },
  methods: {
    handlerChangeState(key, value) {
      this.form.settings[key] = value
    },
    // 获取数据
    async applyDeyail() {
      const { data } = await applyDeyail({ id: this.applyId })
      const staffs = []
      if (Array.isArray(data.staff_ids)) {
        data.staff_ids.forEach(item => {
          staffs.push({
            staff_id: item.staff_id,
            staff_name: item.staff_name,
            staff_name_en: item.staff_name_en,
            staff_name_secondary: item.staff_name_secondary,
            staff_name_th: item.staff_name_th,
            avatar_url: item.avatar_url
          })
        })
      }
      data.staff_ids = staffs
      Object.assign(this.form, data)
      this.formateDataShow()
    },
    // 数据格式化回显
    // '19:20-20:20 分解成俩个值 或者给定默认值'
    formateDataShow() {
      const { settings } = this.form
      otRuleTaps.forEach(item => {
        const allow_apply_time_frame = settings[item].allow_apply_time_frame
        // 可选申请范围回显
        if (allow_apply_time_frame) {
          const times = allow_apply_time_frame.split('-')
          settings[item].start = times[0]
          settings[item].end = times[1]
        }
        // 休息时段回显
        const period = settings[item].rest_time_period
        // 如果为空则创建一条默认值
        if (!period.length) {
          return (settings[item].rest_time_period_formate = [timeInterval(true)])
        }
        // 不为空则回显
        settings[item].rest_time_period_formate = []
        period.forEach(el => {
          const times = el.split('-')
          settings[item].rest_time_period_formate.push({ start: times[0], end: times[1] })
        })
      })
    },
    // 关闭
    handleClose() {
      this.$emit('close')
    },
    // 打开Org选择
    openOrg() {
      if (this.form.is_default === '0') this.orgVisible = true
    },
    // 适用范围人员选择
    handleSelectDepart(selectedOrg) {
      const { staff_list, dept_list } = selectedOrg
      this.form.staff_ids = staff_list
      this.form.department_ids = dept_list
    },
    // 存储前时段格式化
    formateInterval() {
      // 时段格式化
      otRuleTaps.map(item => {
        const itemObj = this.form.settings[item]
        const { rest_time_period_formate } = itemObj
        itemObj.allow_apply_time_frame = `${itemObj.start}-${itemObj.end}`
        itemObj.rest_time_period = rest_time_period_formate.map(el => `${el.start}-${el.end}`)
      })
    },
    // 存储
    handldSave() {
      const request = this.type === 'add' ? applyAdd : applyEdit
      this.formateInterval()
      this.$refs.form.validate(valid => {
        if (valid) {
          request(this.form).then(res => {
            this.handleClose()
            this.$emit('updateList')
            this.$message.success(this.$t('160'))
          })
        }
      })
    }
  }
}
</script>
<style lang="scss">
@import './style.scss';
</style>
